<template>
  <div
    :class="[
      'insta-view',
      isFullScreen ? 'full-screen' : '',
    ]"
  >
    <div
      class="bundle"
      :style="bundleStyle"
    >
      <div
        v-for="(image, index) in images"
        :key="index"
        class="bundle-image-block"
        :class="{ active: index === activeEpisode }"
        :style="squareStyle"
      >
        <img
          :src="image.image"
          class="comic-image"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComicsComponentInstagram',
  props: {
    isFullScreen: {
      type: Boolean,
    },
    season: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    images: [],
    bundles: [],
    bundleSize: 4,
    currentBundleIndex: 0,
    activeEpisode: 0,
    squareStyle: {},
    bundleStyle: {},
    squareSize: 0,
    squareGap: 10,
    thumbnailListStyle: {},
    breakpoints: useBreakpoints()
  }),
  computed: {
    squareInitSizeInPercent() {
      return this.breakpoints.xsOnly ? 95 : this.isFullScreen ? 92 : 85
    },
    maxImages() {
      return this.season === 1 ? 27 : 20
    }
  },
  watch: {
    isFullScreen() {
      this.updateSize()
    },
    season() {
      this.activeEpisode = 0
      this.generateImages()
      this.updateSize()
    }
  },
  mounted() {
    this.generateImages()
    this.updateSize()
    window.addEventListener('resize', this.updateSize)
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateSize)
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    generateImages() {
      this.images = [];
      
      let images = [];
      if (this.season === 1) {
        images = import.meta.glob(`@/assets/images/comics/episodes/season-1/*`, {
          eager: true,
          import: 'default',
        });
      } else {
        images = import.meta.glob(`@/assets/images/comics/episodes/season-2/*`, {
          eager: true,
          import: 'default',
        });
      }

      for (let i = 1; i <= this.maxImages; i += 1) {
        this.images.push(
          {
            image: images[`/assets/images/comics/episodes/season-${this.season}/${i}.webp`],
          },
        );
      }
    },
    nextEpisode() {
      this.activeEpisode = (this.activeEpisode + 1) % this.maxImages;
    },
    prevEpisode() {
      this.activeEpisode = Math.max(0, (this.activeEpisode - 1));
    },
    updateSize() {
      const vh = window.innerHeight * 0.01;
      const vw = window.innerWidth * 0.01;

      this.squareSize = Math.min(vh, vw) * this.squareInitSizeInPercent;
      this.squareSize = Math.max(this.squareSize, 280);
      this.squareStyle = {
        width: `${this.squareSize}px`,
        height: `${this.squareSize}px`,
      };
      this.bundleStyle = {
        gap: `${this.squareGap}px`,
        height: `calc(${this.maxImages} * ${this.squareSize}px + (${this.maxImages - 1} * ${this.squareGap}px))`,
      };
    },
    handleClickUnActiveEpisode(clickedIndex) {
      if (this.activeEpisode + 1 === clickedIndex) {
        this.nextEpisode();
      }
      else if (this.activeEpisode - 1 === clickedIndex) {
        this.prevEpisode();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.insta-view {
  overflow-x: hidden;
  overflow-y: scroll;
  height: calc(100dvh - 110px);
  padding-bottom: 100px;
}
.insta-view.full-screen {
  height: 100dvh;
}
.bundle {
  display: flex;
  transition: all 1s ease;
  flex-direction: column;
  justify-content: center;
}

.bundle-image-block {
  position: relative;
  transition: all 1s ease;
  margin: 0 auto;

  .comic-image {
    border-radius: 32px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
